import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RecoverState } from './recover.state';

/**
 * Selects the main recover state
 * @param appState The global state
 */
export const selectRecoverState = createFeatureSelector<RecoverState>('recover');

/**
 * Selects the orders returned from GuestOrderSearch
 */
export const selectOrders = createSelector(selectRecoverState, (state: RecoverState) => {
	return state.orders;
});

/**
 * Selects the email used for GuestOrderSearch
 */
export const selectRecoverEmail = createSelector(selectRecoverState, (state: RecoverState) => {
	return state.email;
});

/**
 * Selects the order_id returned from GuestOrderSearch
 */
export const selectRecoverOrderId = createSelector(selectRecoverState, (state: RecoverState) => {
	return state.order_id;
});

/**
 * Selects the phone number used for GuestOrderSearch
 */
export const selectRecoverPhone = createSelector(selectRecoverState, (state: RecoverState) => {
	return state.phone;
});

/**
 * Selects the eToken used for Verify PaymentPortalLogin
 */
export const selectRecoverEToken = createSelector(selectRecoverState, (state: RecoverState) => {
	return state.eToken;
});

/**
 * Selects the oToken used for Verify PaymentPortalLogin
 */
export const selectRecoverOToken = createSelector(selectRecoverState, (state: RecoverState) => {
	return state.oToken;
});

/**
 * Selects the cToken for the current order
 */
export const selectRecoverCToken = createSelector(selectRecoverState, (state: RecoverState) => {
	return state.cToken;
});

/**
 * Selects the barcode for the current order
 */
export const selectRecoverBarcode = createSelector(selectRecoverState, (state: RecoverState) => {
	return state.barcode;
});
